<!--
  3d-force-graph Plugin

  @since: 2018-05-03
  @author: mk.ko
-->

<template>
  <div ref="forceGraph"
       class="force-graph">
  </div>
</template>

<script>
  // import ForceGraph from '3d-force-graph'
  import ForceGraph from './3d-force-graph'

  // import * as d3 from 'd3'
  // import * as THREE from 'three'

  // 3d-force-graph (version: 1.67.8)
  export default {
    name: 'ForceGraph',
    components: {},
    directives: {},
    mixins: [],
    props: {},
    data () {
      return {
        self: this,
        afterRenderTimerObject: void 0,
        graphProps: [
          // Initialisation
          'controlType', 'rendererConfig', 'extraRenderers',

          // Data Input
          'graphData', 'jsonUrl', 'nodeId', 'linkSource', 'linkTarget',

          // Container layout
          'width', 'height', 'backgroundColor', 'showNavInfo',

          // Node styling
          'nodeRelSize', 'nodeVal', 'nodeLabel', 'nodeVisibility', 'nodeColor', 'nodeAutoColorBy',
          'nodeOpacity', 'nodeResolution', 'nodeThreeObject', 'nodeThreeObjectExtend',

          // Link styling
          'linkLabel', 'linkVisibility', 'linkColor', 'linkAutoColorBy', 'linkOpacity', 'linkWidth',
          'linkResolution', 'linkCurvature', 'linkCurveRotation', 'linkMaterial', 'linkThreeObject',
          'linkThreeObjectExtend', 'linkPositionUpdate', 'linkDirectionalArrowLength',
          'linkDirectionalArrowColor', 'linkDirectionalArrowRelPos', 'linkDirectionalArrowResolution',
          'linkDirectionalParticles', 'linkDirectionalParticleSpeed', 'linkDirectionalParticleWidth',
          'linkDirectionalParticleColor', 'linkDirectionalParticleResolution', 'emitParticle',

          // Render control (따로 함수로 정의)

          // Force engine configuration
          'forceEngine', 'numDimensions', 'dagMode', 'dagLevelDistance',
          'dagNodeFilter', 'onDagError', 'd3AlphaMin',
          'd3AlphaDecay', 'd3VelocityDecay',
          'd3Force', 'd3ReheatSimulation', 'ngraphPhysics',
          'warmupTicks', 'cooldownTicks', 'cooldownTime',
          'onEngineTick', 'onEngineStop',

          // Interaction
          'onNodeClick', 'onNodeRightClick', 'onNodeHover', 'onNodeDrag', 'onNodeDragEnd',
          'onLinkClick', 'onLinkRightClick', 'onLinkHover', 'onBackgroundClick', 'onBackgroundRightClick',
          'linkHoverPrecision', 'enablePointerInteraction', 'enableNodeDrag', 'enableNavigationControls'

          // Utility (따로 정의)
        ],
        graph: {},
        options: {}
      }
    },
    computed: {},
    methods: {
      /* =====================================
       * Binding Method
       *  - Render Control
       *  - Utility
       * ===================================== */
      // Render Control
      pauseAnimation () {
        try {
          return this.graph.pauseAnimation()
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (pauseAnimation)]', e)
        }
      },
      resumeAnimation () {
        try {
          return this.graph.resumeAnimation()
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (resumeAnimation)]', e)
        }
      },
      cameraPosition (...arg) {
        try {
          return this.graph.cameraPosition(...arg)
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (cameraPosition)]', e)
        }
      },
      zoomToFit (...arg) {
        try {
          return this.graph.zoomToFit(...arg)
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (zoomToFit)]', e)
        }
      },
      postProcessingComposer () {
        try {
          return this.graph.postProcessingComposer()
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (postProcessingComposer)]', e)
        }
      },
      scene () {
        try {
          return this.graph.scene()
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (scene)]', e)
        }
      },
      camera () {
        try {
          return this.graph.camera()
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (camera)]', e)
        }
      },
      renderer () {
        try {
          return this.graph.renderer()
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (renderer)]', e)
        }
      },
      controls () {
        try {
          return this.graph.controls()
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (controls)]', e)
        }
      },
      refresh () {
        try {
          return this.graph.refresh()
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (refresh)]', e)
        }
      },

      // Utility
      getGraphBbox (...arg) {
        try {
          return this.graph.getGraphBbox(...arg)
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (getGraphBbox)]', e)
        }
      },
      graph2ScreenCoords (...arg) {
        try {
          return this.graph.graph2ScreenCoords(...arg)
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (graph2ScreenCoords)]', e)
        }
      },
      screen2GraphCoords (...arg) {
        try {
          return this.graph.screen2GraphCoords(...arg)
        } catch (e) {
          this.$log('[Force Graph 3D GUI Error (screen2GraphCoords)]', e)
        }
      },

      /* =====================================
       * Define Method
       * ===================================== */
      render (conf) {
        const forceGraph = this.$refs.forceGraph

        // const options = this.$props.options
        let options = {}
        options = this.options = Object.assign(options, conf)
        const props = Object.keys(options)
        // let count = 0

        if (props.length > 0) {
          // default settings
          // const nodeRelSize = options['nodeRelSize'] || 5

          // const self = this.self
          if (_.isEmpty(this.graph)) {
            this.graph = ForceGraph()(forceGraph)
            this.graph.pauseAnimation()
          } else {
            this.graph.pauseAnimation()
            this.graph.graphData({ nodes: [], links: [] })
          }
          this.graph.graphData(options.graphData)
            // .dagMode('td') // dag mode 관련
            // .dagLevelDistance(40) //
            .width(options.width || 0)
            .height(options.height || 0)
            // .d3VelocityDecay(0.4)
            .showNavInfo(false)
            .enablePointerInteraction(true) // 라벨, 노드 클릭 이벤트 관련 (default:true)
            .enableNodeDrag(true)               // 클릭 이벤트 관련
            .enableNavigationControls(true) // default: true
            // .onEngineStop(() => {
            //   vm.graph.d3VelocityDecay(1)
            // })
            // .d3Force('collision', d3.forceCollide(node => Math.cbrt(node.size) * nodeRelSize))
            // .d3Force('collision', d3forceCollide(node => Math.cbrt(node.size * nodeRelSize)))
            // .d3Force('collision', d3.forceCollide().radius(d => d.radius)
            // .d3Force('link', d3.forceLink())
            // .d3Force('charge', d3.forceManyBody())
          // .forceEngine('ngraph')
          // .onNodeHover(node => {
          //   this.$refs.forceGraph.style.cursor = node ? 'pointer' : null
          // })

          // set options properties
          props.forEach((prop, idx) => {
            if (this.graphProps.indexOf(prop) !== -1) {
              switch (prop) {
                // case 'd3VelocityDecay':
                case 'width':
                case 'height':
                case 'graphData':
                  // 아무 옵션도 먹이지 않음. 기본옵션 우선 선언
                  break
                case 'd3Force':
                  const d3ForceKeys = Object.keys(options.d3Force)
                  d3ForceKeys.forEach(key => {
                    this.graph.d3Force(key, options.d3Force[key])
                  })
                  break
                default:
                  this.graph[prop](options[prop])
              }
            }
          })

          this.graph.resumeAnimation()

          // 화면 랜더링 이후
          this.afterRenderTimerObject = setTimeout(this.afterRender, 0)
        }
      },

      afterRender () {
        try {
          this.$emit('afterRender')
        } catch (e) {
          this.$log('[Force Graph 3D Component GUI Error (afterRender)]', e)
        }
      },

      // Getter
      getGraphInstance () {
        return this.graph
      },
      getRefsForceGraph () {
        return this.$refs.forceGraph
      },

      // Redraw
      redrawGraph (data) {
        if (!_.isEmpty(this.graph)) {
          const options = this.options
          options['graphData'] = (typeof data !== 'undefined') ? data : this.graph.graphData()

          // this.graph.d3VelocityDecay(0.4)
          // if (options.hasOwnProperty('linkMaterial')) {
          //   this.graph.linkMaterial(options.linkMaterial)
          // }
          // this.graph.d3VelocityDecay(1)
          this.graph.graphData(options['graphData'])
          this.graph.refresh() // node_modules 업데이트 이후, node/link 모델 갱신안됨현상 해결 (local build 아닐경우)
            // .d3VelocityDecay(1)
          // this.graph.d3VelocityDecay(0.4)

          // this.afterRender() // init 모드가 아니면 갱신 필요 없음
        }
      },

      onResize (width, height) {
        if (!_.isEmpty(this.graph)) {
          this.graph.width(width)
            .height(height)
        }
      },

      onChangeDimension (numDimension) {
        if (!_.isEmpty(this.graph)) {
          // if (numDimension === 2) {
          //   this.graph.enableNodeDrag(false)
          // } else if (numDimension === 3) {
          //   this.graph.enableNodeDrag(true)
          // }
          this.graph.enableNodeDrag(false)
          this.graph.numDimensions(numDimension)
        }
      }
    },
    beforeCreate () {},
    created () {
      // setTimeout(() => {
      //   this.$refs.forceGraph.parentElement.parentElement.parentElement.addEventListener('resize', this.onResize)
      // })
      // window.addEventListener('resize', this.onResize)
    },
    beforeMount () {},
    mounted () {
      // this.$nextTick(() => {
      //   this.render()
      // })
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // this.$refs.forceGraph.parentElement.parentElement.parentElement.removeEventListener('resize', this.onResize)
      // window.removeEventListener('resize', this.onResize)

      // After Render Timer
      if (typeof this.afterRenderTimerObject !== 'undefined') {
        clearTimeout(this.afterRenderTimerObject)
      }
      if (!_.isEmpty(this.graph)) {
        this.graph.pauseAnimation()
        this.graph.graphData({nodes: [], links: []})
      }
      this.graph = null

      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    watch: {}
  }
</script>

<style scoped>
  .force-graph {
    width: 100%;
    height: 100%;
  }

  .force-graph .scene-tooltip {
    color: black;
  }

  .force-graph .graph-info-msg {
    top: 50%;
    width: 100%;
    text-align: center;
    color: black;
    opacity: 0.7;
    font-size: 22px;
  }

  .force-graph .graph-tooltip {
    color: black;
    font-size: 18px;
    transform: translate(-50%, 25px);
  }
</style>
